import 'magnific-popup';

$('.js-popup-iframe').magnificPopup({
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,
});
